var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-dialog',{attrs:{"value":_vm.item.visible},on:{"update:returnValue":_vm.close},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Some title here")]},proxy:true},{key:"content",fn:function(){return [_vm._v("Some text here")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }